<template>
  <HeaderBar />

  <ButtonBackContainer>
    <ButtonBack :fallback="{ name: 'transferDetail', params: { id: transfer?.id } }">{{
      t('back')
    }}</ButtonBack>
  </ButtonBackContainer>

  <section class="carvia-container">
    <div v-if="transfer && allocation && car">
      <TransferBasicData :transfer="transfer" :booking-allocation="allocation" />

      <Divider />

      <TransferAddresses :transfer="transfer" />

      <Divider />

      <TransferTimes :transfer="transfer" :booking-allocation="allocation" />

      <Divider />

      <VehicleAndTimes :booking-or-allocation="allocation" :car="allocation.car" />
    </div>
    <div v-else class="flex justify-center">
      <Spinner />
    </div>
  </section>
</template>

<script lang="ts" setup>
import HeaderBar from '@/components/headerbar/HeaderBar.vue';
import { useI18n } from 'vue-i18n';
import ButtonBack from '@/components/buttons/ButtonBack.vue';
import { useCar } from '@/queries/use-cars';
import { useUiStore } from '@/stores/ui.store';
import { computed, ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import ButtonBackContainer from '@/components/ButtonBackContainer.vue';
import { useAllocation, useUpdateAllocation } from '@/queries/use-allocations.ts';
import { AllocationType, type UpdateAllocationDto } from '@carvia/ros-client-types';
import TransferBasicData from './components/TransferBasicData.vue';
import TransferAddresses from './components/TransferAddresses.vue';
import TransferTimes from './components/TransferTimes.vue';
import VehicleAndTimes from '@/components/booking-forms/VehicleAndTimes.vue';
import Divider from '@/components/Divider.vue';

const uiStore = useUiStore();
const { t } = useI18n();
const route = useRoute();
const allocationId = ref(route.params.allocationId as string);
const transferId = ref(route.params.transferId as string);
const transferType = ref<AllocationType>(route.params.transferType as AllocationType);
const { data: allocation } = useAllocation(allocationId.value);
const { data: transfer } = useAllocation(transferId);
const carId = computed(() => allocation.value?.car.id ?? '');
const carFetchingEnabled = computed(() => !!allocation.value?.id);
const { data: car } = useCar(carId, carFetchingEnabled);

watchEffect(() => {
  const title = t(transferType.value === AllocationType.TRANSFER_DELIVERY ? 'delivery' : 'return');
  if (allocation.value) {
    const { booking, car } = allocation.value;
    uiStore.setHeaderTitle(
      title,
      `${booking?.customerData?.firstName ?? 'n/a'} ${booking?.customerData?.lastName ?? 'n/a'}`,
      `${car.vehicleType?.make.name} ${car.vehicleType?.model}`,
    );
  } else {
    uiStore.setHeaderTitle(title);
  }
});
</script>

<i18n lang="json">
{
  "en": {
    "booking": "Booking",
    "delivery": "Delivery",
    "return": "Return"
  },
  "de": {
    "booking": "Buchung",
    "delivery": "Anlieferung",
    "return": "Rückführung"
  },
  "es": {
    "booking": "Reserva",
    "delivery": "Entrega",
    "return": "Recogida"
  }
}
</i18n>
